import React from "react";

import Hospital from "../../../assets/images/Icons/Hospital.svg";

//Style
import { MDBListGroup, MDBListGroupItem } from "mdbreact";
import "./SideBarRight.scss";
import { useSelector } from "react-redux";
import { Language } from "../../../redux/store/base/language";

const SideBarRight = (props: {}) => {
  const state = useSelector(
    (state: { lang: Language }) => state.lang.dictionary
  );

  return (
    <section className="side-rigth px-3">
      <MDBListGroup>
        <MDBListGroupItem>
          <img src={Hospital} className="d-inline-inline mx-3" alt={"Home"} />
          <p>{state?.hospitals}</p>
        </MDBListGroupItem>
        <MDBListGroupItem className="active">
          <p>{state?.allhospitals}</p>
        </MDBListGroupItem>
        <MDBListGroupItem>
          <p>{state?.generalHospitals}</p>
        </MDBListGroupItem>
        <MDBListGroupItem>
          <p>{state?.specializedMedicalCenter}</p>
        </MDBListGroupItem>
        <MDBListGroupItem className="more">
          <p>{state?.showMore}</p>
        </MDBListGroupItem>
      </MDBListGroup>
    </section>
  );
};

export default SideBarRight;
